// @ts-nocheck
import {Column} from 'react-table'
import {UserCustomHeader} from '../apps/user-management/users-list/table/columns/UserCustomHeader'
import {StockLevelRecord} from './api'

const getStockLevelColumns = (): ReadonlyArray<Column<StockLevelRecord>> => [
  {
    Header: (props) => (
      <UserCustomHeader
        tableProps={props}
        title='Warehouse'
        className='min-w-150px ps-4 text-center'
      />
    ),
    id: 'warehouseName',
    accessor: 'warehouseName',
    sortType: 'alphanumeric',
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Product' className='min-w-150px text-center' />
    ),
    accessor: 'productName',
    sortType: 'alphanumeric',
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='SKU Code' className='min-w-125px text-center' />
    ),
    accessor: 'skuCode',
    sortType: 'alphanumeric',
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Category' className='min-w-125px text-center' />
    ),
    accessor: 'category',
    sortType: 'string',
  },
  {
    Header: (props) => (
      <UserCustomHeader
        tableProps={props}
        title='Price / Unit'
        className='min-w-125px text-center'
      />
    ),
    accessor: 'pricePerUnit',
    sortType: 'basic',
    Cell: ({...props}) => <div>&#8377; {props.data[props.row.index].pricePerUnit}</div>,
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='UOM' className='min-w-100px text-center' />
    ),
    accessor: 'unit',
    sortType: 'string',
    Cell: ({...props}) => (
      <span className='badge badge-light-dark fw-bold'>{props.data[props.row.index].unit}</span>
    ),
  },
]

export {getStockLevelColumns}
